import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { LoggerService } from 'src/app/logger.service';
import { LoginService } from '../login/login.service';
import { GenericpopupComponent } from '../../v2/components/genericpopup/genericpopup.component';
import { TranslatorService } from 'src/app/translator.service';

@Component({
  selector: 'app-tutorial',
  templateUrl: './tutorial.page.html',
  styleUrls: ['./tutorial.page.scss'],
})
export class TutorialPage implements OnInit {

  constructor(private loggerService: LoggerService, private loginService: LoginService, private modalCtrl: ModalController, public translator: TranslatorService) { }
  public platform = "";
  public chatmessage;
  public chatemail;
  public chatname;
  public isTeacher = false;
  public isStudent = false;

  ngOnInit() {
  }
  ionViewWillEnter() {
    this.platform = this.loggerService.getPlatorm();
    //console.log(this.loginService.activeUser)
    if (this.loginService.activeUser != null) {
      this.isTeacher = this.loginService.activeUser.isTeacher;
      this.isStudent = !this.isTeacher;
    }
    else {
      let bodyMessage = "";
      let buttons = [{ label: this.translator.lang['tutorialpopupstudent'], action: 0 }, { label: this.translator.lang['tutorialpopupteacher'], action: 1 }];
      this.modalCtrl.create({
        component: GenericpopupComponent,
        componentProps: { title: this.translator.lang['tutorialcat'], body: bodyMessage, buttons: buttons },
        backdropDismiss: false,
        cssClass: "modal-fullscreen"
      }).then(modalEl => {
        modalEl.present();
        modalEl.onDidDismiss().then(result => {
          if (+result.data.action === 0) {
            this.isStudent = true;
          }
          else {
            this.isTeacher = true;
          }
        })
      })
    }
  }
  sendMessage() {

    if (this.chatmessage != undefined && this.chatemail != undefined && this.chatname != undefined) {
      this.loginService.sendMailToOffice(this.chatname, this.chatemail, this.chatmessage);
      this.chatmessage = "";
      this.chatname = "";
      this.chatemail = "";
    }
    else {
      alert("Completează numele, adresa de email si mesajul tău pentru a putea trimite un mesaj către echipa Teste Scolare.")
    }

  }
}
